import api from '@/api/stage';
import store from '@/store';
import popup from '@/model/popup';
import userCustomSettings from '@/model/userCustomSettings';

// todo move to utils
class StoreList {
  constructor(getter, committer) {
    this.getter = getter;
    this.committer = committer;
  }

  getList() {
    return this.getter;
  }

  setList(list) {
    this.committer(list);
  }

  add(item) {
    const items = this.getter();
    this.committer([...items, item]);
  }

  replace(newItem, prevItem) {
    const items = this.getter();

    const mapper = prevItem
      ? (i) => (i === prevItem ? newItem : i)
      : (i) => (i.id === newItem.id ? newItem : i);

    this.committer(items.map(mapper));
  }

  remove(item) {
    const items = this.getter();
    const updated = items.filter((i) => i.id !== item.id);
    this.committer(updated);
  }
}

const itemsGetter = () => store.getters['stage/itemsHydrated'];
const committer = (items) => { store.commit('stage/setItems', items); };

const storeList = new StoreList(itemsGetter, committer);

export default {
  addToList(project) {
    const newItem = { project: project['@id'], name: '' };
    storeList.add(newItem);
    this.edit(newItem);
  },
  swap(item1, indexDelta) {
    const items = [...itemsGetter()] ?? [];

    if (items.length) {
      const index = items.indexOf(item1);
      items[index] = items[index + indexDelta];
      items[index + indexDelta] = item1;
    }

    this.resort(items);
  },
  resort(items) {
    const sort = Object.fromEntries(items.map((item, index) => ([item.id, index])));

    const stageSort = { ...store.state.auth.user.customSettings?.stageSort } ?? {};
    const projectId = store.state.project.project.id;

    if (JSON.stringify(stageSort[projectId]) === JSON.stringify(sort)) return;

    stageSort[projectId] = sort;

    userCustomSettings.set({ stageSort });
  },
  async saveInList(item) {
    if (item.id) {
      const response = await api.update(item.id, item, true);
      storeList.replace(response);
    } else {
      const response = await api.create(item, true);
      storeList.replace(response, store.state.stage.editingItem);
    }

    this.cancelEdit();
  },
  async deleteFromList(item) {
    if (await popup.addConfirm(`Вы действительно хотите удалить раздел [${item.name}]?`)) {
      api.delete(item.id, true)
        .then(() => { storeList.remove(item); })
        .catch((err) => {
          const msg = err.description === 'Unable to delete stage with tasks'
            ? 'Невозможно удалить раздел с задачами'
            : 'При удалении раздела произошла ошибка';
          popup.addAlert(msg);
        });
    }
  },

  edit(item) {
    store.commit('stage/setEditingItem', item);
  },
  cancelEdit() {
    const editing = store.state.stage.editingItem;

    if (!editing) return;

    if (!editing.id) {
      storeList.remove(editing);
    }

    store.commit('stage/setEditingItem', null);
  },
};
